
import { useParams } from "react-router-dom";
import { useLoteXID } from "../../../hooks";
import { DisenioPaginas } from "../../layout";
import { CargandoMedio, FormCreateUpdateLote } from "../../components";



export const ActualizarLote = () => {


    const { id } = useParams();
    const { loteXIDQuery } = useLoteXID(`${id}`);
    const lote = loteXIDQuery?.data



    const initialState = (lote) ? {
        lote: lote.lote || '',
        granja: lote?.granja?._id || '',
        encubadora: lote?.encubadora?._id || '',
        cantidadTotal: lote.cantidadTotal || '',
        factura: lote.factura || '',
        machos: lote.machos || '',
        hembras: lote.hembras || '',
        id: lote.id || "",
    } : {};



    return (

        <DisenioPaginas titulo="Actualizar Lote" url={1} add={false} subtitulo="Información del lote">
            {(loteXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Lote..." />
            :   <FormCreateUpdateLote initialState={initialState} />
            }
        </DisenioPaginas>


    )
}
